import { render, staticRenderFns } from "./CrudCreateButton.vue?vue&type=template&id=2e273753&scoped=true&lang=pug&"
import script from "./CrudCreateButton.vue?vue&type=script&lang=js&"
export * from "./CrudCreateButton.vue?vue&type=script&lang=js&"
import style0 from "./CrudCreateButton.vue?vue&type=style&index=0&id=2e273753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e273753",
  null
  
)

component.options.__file = "CrudCreateButton.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
